import {
  Boolean as RTBoolean,
  Null,
  Partial,
  Record,
  Static,
  String as RTString,
  Undefined
} from 'runtypes';
import { Address } from './address';

export const AdditionalCustomer = Partial({
  customerType: RTString,
  name: Record({
    firstName: RTString,
    middleName: RTString.Or(Undefined),
    lastName: RTString
  }),
  dob: RTString,
  taxID: RTString,
  citizenship: RTString,
  residentialAddress: Address,
  sameAddress: RTBoolean
});

export type StaticAdditionalCustomer = Static<typeof AdditionalCustomer>;

export const CoTrustee = Partial({
  name: Record({
    firstName: RTString,
    middleName: RTString.Or(Undefined),
    lastName: RTString
  }),
  citizenship: RTString,
  dob: RTString,
  taxID: RTString,
  taxIDType: RTString,
  residentialAddress: Address
});

export type StaticCoTrustee = Static<typeof CoTrustee>;

export const Trust = Record({
  name: RTString,
  trustDate: RTString,
  taxID: RTString,
  taxIDSSN: RTBoolean.Or(Undefined).Or(Null),
  address: Address
});

export type StaticTrust = Static<typeof Trust>;
